import * as React from 'react';
import { SVGProps } from 'react';
import { useTheme } from '@mui/material/styles';

const Logo = () => {
  const theme = useTheme();
  return (
    <img
      src='./multi-services.png'
      style={{
        width: 200,
      }}
    />
  );
};

export default Logo;
